import { render, staticRenderFns } from "./UserPassword.vue?vue&type=template&id=2d085562&scoped=true"
import script from "./UserPassword.vue?vue&type=script&lang=js"
export * from "./UserPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d085562",
  null
  
)

export default component.exports